import { useState } from "react";
import { Button, OverlayTrigger, ToggleButton, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { Lightbox } from "components/Lightbox";
import { isMobile } from "utils/isMobile";

interface Props {
  type: "success" | "warning" | "danger" | undefined;
  isChecked: boolean;
  index: number;
  isDisabled?: boolean;
  onClick: (index: number, value: boolean) => void;
}

const Tip: React.FC<Props> = ({ type, isChecked, index, isDisabled = false, onClick }) => {
  const [isMobileModalOpen, setIsMobileModalOpen] = useState(false);
  const { t } = useTranslation(["exercise"]);

  // Show only, if answer is not wrong
  if (type !== "success" && type !== "warning") return null;

  // If on results screen, show only if is checked
  if (isDisabled && !isChecked) return null;

  const handleConfirm = (checked: boolean) => {
    onClick(index, checked);
  };

  const handleClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (isMobile() && event.currentTarget.checked) setIsMobileModalOpen(true);
    else handleConfirm(event.currentTarget.checked);
  };

  const renderButton = () => (
    <ToggleButton
      value={1}
      variant={"select"}
      className={"btn-shadow btn-emoji btn-emoji--thin"}
      type="checkbox"
      checked={isChecked || isDisabled}
      id={`toggle-check_${index}`}
      onChange={handleClick}
      title={t("btnTitle.guessed", { ns: "exercise" })}
      disabled={isDisabled}
    >
      <div id="tip" className="d-flex flex-column">
        {t("btn.guessed", { ns: "exercise" })}
        {isDisabled ? <small>tipnuto</small> : null}
      </div>
    </ToggleButton>
  );

  return (
    <>
      {isMobile() ? (
        renderButton()
      ) : (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id={`tooltip-tip-${index}`}>{t("guessed.tooltipText", { ns: "exercise" })}</Tooltip>}
        >
          {renderButton()}
        </OverlayTrigger>
      )}

      {/* Vysvětlivka nemá nadpis, jen odstavec — jméno dialogu je proto neviditelné.
          Rozhodnuto se zadavatelem 31. 8. 2026. [TD-344] */}
      <Lightbox
        show={isMobileModalOpen}
        onHide={() => {
          setIsMobileModalOpen(false);
        }}
        ariaLabel="Vysvětlení"
      >
        <p className="text-center mb-20px">{t("guessed.tooltipText", { ns: "exercise" })}</p>
        <Button
          className="w-100"
          onClick={() => {
            handleConfirm(true);
            setIsMobileModalOpen(false);
          }}
        >
          OK, pokračovat
        </Button>
      </Lightbox>
    </>
  );
};

export default Tip;
